var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "city-confirmation-modal",
      attrs: { visible: _vm.$city.isCityConfirmationShown, "allow-close": "" },
      on: {
        "on-close": function($event) {
          return _vm.$city.hideCityConfirmation()
        }
      }
    },
    [_c("city-confirmation", { on: { choose: _vm.choose } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }